export default "__VITE_ASSET__DyC8kOZx__"